import React, { useState, useEffect,useRef } from 'react';
import { FaArrowUp, FaArrowDown, FaShoppingCart, FaUsers } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const ProfitLoss = ({ data, fromDate, toDate, setFromDate, setToDate, handleFilter }) => {
  const { product_profit_data, suppliers_credit_data, suppliers_data } = data;
  const [productData, setProductData] = useState(product_profit_data || []);
  const [suppliersCreditData, setSuppliersCreditData] = useState(suppliers_credit_data || []);
  const [suppliersData, setSuppliersData] = useState(suppliers_data || []);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const modalContentRef = useRef(null);


  useEffect(() => {
    setProductData(product_profit_data || [])
    setSuppliersCreditData(suppliers_credit_data || [])
    setSuppliersData(suppliers_data || [])
  }, [product_profit_data, suppliers_credit_data, suppliers_data])

  const totalProfit = productData?.reduce((acc, p) => acc + p.profit, 0).toFixed(3);
  const totalLoss = productData?.reduce((acc, p) => acc + p.loss, 0).toFixed(3);
  const totalSupplierCredit = suppliersCreditData?.reduce((acc, s) => acc + s.total_amount, 0).toFixed(3);
  const totalSupplierPurchases = suppliersData?.reduce((acc, s) => acc + s.total_amount, 0).toFixed(3);
  const totalSupplier = suppliersData?.reduce((acc, s) => acc + s.total_amount, 0).toFixed(3);

  const accounts = {
    sales: parseFloat(totalProfit),
    numSales: productData.length,
    topCustomers: "N/A",
    purchaseExpense: parseFloat(totalSupplierPurchases),
    purchaseCredit: parseFloat(totalSupplierCredit),
    numPurchases: suppliersData.length,
    topSupplier: suppliersData[0]?.supplier_name || "N/A",
    salaryExpense: parseFloat(totalSupplier),
    numEmployees: 0,
    loss:parseFloat(totalLoss),
  };

  // Handle print functionality (simplified for now)
  const handlePrint = async () => {
    const content = modalContentRef.current; 

    if (!content) {
        console.error("Modal content not found for printing");
        return;
    }

    try {
        const canvas = await html2canvas(content, { scale: 3 });
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");

        const pdfWidth = pdf.internal.pageSize.getWidth(); // A4 width
        const pdfHeight = pdf.internal.pageSize.getHeight(); // A4 height

        const imgWidth = 200;
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Keep aspect ratio

        // Center the image in PDF
        const xOffset = (pdfWidth - imgWidth) / 2;
        const yOffset = (pdfHeight - imgHeight) / 2;

        pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);

        const pdfBlob = pdf.output("blob");
        const pdfUrl = URL.createObjectURL(pdfBlob);

        const printWindow = window.open(pdfUrl, "_blank");

        if (printWindow) {
            printWindow.onload = () => {
                printWindow.print();
            };
        } else {
            console.error("Failed to open the print window");
        }

        URL.revokeObjectURL(pdfUrl);
    } catch (error) {
        console.error("Failed to generate or print the PDF:", error);
    }
};

  return (
    <div className="card">
      <div className="my-4 mx-4 mt-1">
        <h4 className="fw-semibold text-dark mb-3 mt-3 p-1">📊 Product & Supplier Overview</h4>
        <form onSubmit={handleFilter} className="card p-1 shadow-sm">
          <div className="row g-3 justify-content-end align-items-center">
            {/* From Date */}
            <div className="col-md-2">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  id="fromDate"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value)
                  }}
                />
                <label htmlFor="fromDate">From Date</label>
              </div>
            </div>

            {/* To Date */}
            <div className="col-md-2">
              <div className="form-floating">
                <input
                  type="date"
                  className="form-control"
                  id="toDate"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
                <label htmlFor="toDate">To Date</label>
              </div>
            </div>

            {/* Filter Button */}
            <div className="col-md-2 d-flex align-items-end flex-column">
              <button
                className="btn btn-primary w-100 bg-gradient-kyoto p-1 mb-1"
              onClick={() => { setShowModal(true) }}
              >
                Overview
              </button>
              <button
                type="submit"
                className="btn btn-primary w-100 p-10"
                style={{
                  background: 'linear-gradient(45deg, #007bff, #6610f2)',
                  border: 'none',
                }}
              >
                <i className="fas fa-filter"></i> Filter
              </button>
            </div>
          </div>
        </form>
        <div className="row g-3">
          <div className="col-md-3">
            <div className="card shadow border-0 bg-success text-white p-3">
              <h6>Total Profit</h6>
              <h3>{totalProfit}</h3>
              <FaArrowUp className="fs-2 opacity-75" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="card shadow border-0 bg-danger text-white p-3">
              <h6>Total Loss</h6>
              <h3>{totalLoss}</h3>
              <FaArrowDown className="fs-2 opacity-75" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="card shadow border-0 bg-primary text-white p-3">
              <h6>Supplier Credit</h6>
              <h3>{totalSupplierCredit}</h3>
              <FaUsers className="fs-2 opacity-75" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="card shadow border-0 bg-warning text-white p-3">
              <h6>Total Purchases</h6>
              <h3>{totalSupplierPurchases}</h3>
              <FaShoppingCart className="fs-2 opacity-75" />
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <div className="card shadow-sm border-0" style={{ minHeight: "90vh" }}>
              <div className="card-header bg-primary text-white">📌 Product Profit & Loss</div>
              <div className="card-body" style={{ maxHeight: "85vh", overflowY: "auto" }}>
                {loading ? (
                  <div className="text-center"><div className="spinner-border text-primary"></div></div>
                ) : productData.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered ">
                      <thead className="table-primary text-center">
                        <tr>
                          <th>Product Name</th>
                          <th>Profit/Loss</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productData.map((product) => (
                          <tr key={product.product_id}>
                            <td>{product.product_name}</td>
                            <td className={product.profit > 0 ? "text-success fw-bold" : "text-danger fw-bold"}>
                              {product.profit > 0 ? `+${product.profit.toFixed(3)}` : `-${product.loss.toFixed(3)}`}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-muted text-center">No product data available</p>
                )}
              </div>
            </div>
          </div>


          {/* Right Side - Supplier Credit & Suppliers Data */}
          <div className="col-md-6">
            <div className="d-flex flex-column gap-1">

              {/* Supplier Credit Data */}
              <div className="card shadow-sm border-0" style={{ minHeight: "41vh" }}>
                <div className="card-header bg-success text-white">💳 Supplier Credit Data</div>
                <div className="card-body" style={{ maxHeight: "33vh", overflowY: "auto" }}>
                  {loading ? (
                    <div className="text-center"><div className="spinner-border text-success"></div></div>
                  ) : suppliersCreditData.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table  table-bordered">
                        <thead className="table-success text-center">
                          <tr>
                            <th>Supplier Name</th>
                            <th>Total Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {suppliersCreditData.map((supplier) => (
                            <tr key={supplier.supplier_id}>
                              <td>{supplier.supplier_name}</td>
                              <td className="fw-bold text-success">{supplier.total_amount.toFixed(3)}</td>
                            </tr>
                          ))}

                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="text-muted text-center">No supplier credit data available</p>
                  )}
                </div>
              </div>

              {/* Suppliers Data */}
              <div className="card shadow-sm border-0" style={{ minHeight: "44vh" }}>
                <div className="card-header bg-info text-white">🏢 Suppliers Data</div>
                <div className="card-body" style={{ maxHeight: "38vh", overflowY: "auto" }}>
                  {loading ? (
                    <div className="text-center"><div className="spinner-border text-info"></div></div>
                  ) : suppliersData.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table  table-bordered">
                        <thead className="table-info text-center">
                          <tr>
                            <th>Supplier Name</th>
                            <th>Total Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {suppliersData.map((supplier) => (
                            <tr key={supplier.supplier_id}>
                              <td>{supplier.supplier_name}</td>
                              <td className="fw-bold text-primary">{supplier.total_amount.toFixed(3)}</td>
                            </tr>
                          ))}

                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="text-muted text-center">No supplier data available</p>
                  )}
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
      
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        tabIndex={-1}
        role="dialog"
        style={{ display: showModal ? "block" : "none", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        aria-hidden={!showModal}
      >
        <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content shadow-lg bg-none rounded-3" ref={modalContentRef}>

          <div className="modal-content shadow-lg rounded-3 p-3">
            <div >
          <button type="button " className="btn-close float-end" aria-label="Close" onClick={() => setShowModal(false)}></button>

            <div className="modal-header border-0 pb-0">
              <div className="row mx-3 mt-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="col-md-1">
                      <img
                        src="assets/images/tech_logo.webp"
                        alt="Left Logo"
                        style={{ maxHeight: "38px" }}
                      />
                    </div>

                    <div>
                      <img
                        src="assets/images/arabic.jpg"
                        alt="Left Logo"
                        style={{ maxHeight: "38px" }}
                      />
                    </div>
                  </div>

                  <div className="col-12 text-center mt-2">
                    <p className="fw-bold font-14 mb-0">
                      P.O. Box 605/512, AL Khoudh Souq, Muscat, Sultanate of
                      Oman
                    </p>
                    <p className="fw-medium font-13 mb-0">
                      Mobile: +968 91120555 | E-Mail: Sales@toptecno.com |
                      www.toptecno.com
                    </p>
                  </div>
                </div>
            </div>
            <h4 className="fw-semibold text-center w-100 mt-1">Financial Summary</h4>

            </div>

            <div className="row mx-3 mt-3 text-center">
              <div className="col-md-6">
                <label className="fw-bold text-dark">From Date:</label>
                <p className="text-muted">{fromDate}</p>
              </div>
              <div className="col-md-6">
                <label className="fw-bold text-dark">To Date:</label>
                <p className="text-muted">{toDate}</p>
              </div>
            </div>

            <div className="table-responsive mx-3 mt-3 shadow-sm rounded">
      <table className="table table-bordered text-center align-middle">
        <thead className="bg-primary text-white">
          <tr>
            <th scope="col" className="py-3">Category</th>
            <th scope="col" className="py-3">Amount</th>
          </tr>
        </thead>
        <tbody>
          {/* Credit Section */}
          <tr className="bg-primary bg-opacity-10 fw-bold">
            <td colSpan="2" className="text-start py-2 ps-4">Credits</td>
          </tr>
          <tr>
            <td className="text-start ps-4">Total Supplier Credit</td>
            <td className="fw-medium">₹{accounts.purchaseCredit.toFixed(3)}</td>
          </tr>

          {/* Purchase Section */}
          <tr className="bg-primary bg-opacity-10 fw-bold">
            <td colSpan="2" className="text-start py-2 ps-4">Purchases</td>
          </tr>
          <tr>
            <td className="text-start ps-4">Total Purchase Expense</td>
            <td className="fw-medium">₹{accounts.purchaseExpense.toFixed(3)}</td>
          </tr>

          {/* Profit Section */}
          <tr className="bg-primary bg-opacity-10 fw-bold">
            <td colSpan="2" className="text-start py-2 ps-4">Profit & Loss</td>
          </tr>
          <tr className="table-danger">
            <td className="text-start ps-4 fw-bold">Total Loss</td>
            <td className="fw-bold">₹{Math.max(accounts.loss, 0).toFixed(3)}</td>
          </tr>
          <tr className="table-success">
            <td className="text-start ps-4 fw-bold">Total Profit</td>
            <td className="fw-bold">₹{Math.max(accounts.sales - accounts.purchaseExpense, 0).toFixed(3)}</td>
          </tr>
        </tbody>
      </table>
    </div>


            <div className="modal-footer d-flex justify-content-center border-0 mt-4">
              <button type="button" onClick={handlePrint} className="btn btn-success px-4 fw-bold shadow-sm">
                <i className="fas fa-print me-2"></i> Print Summary
              </button>
            </div>
          </div>
         </div>
        </div>
      </div>
    </div>
  );
};

export default ProfitLoss;